module.exports = __webpack_public_path__ + "static/img/第十六届.c385b74.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十六届.png
// module id = B5Ju
// module chunks = 1